import { TariffMappingConstant } from "presentation/constant/TariffMapping/TariffMappingConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useTariffMappingVM } from "presentation/hook/TariffMapping/useTariffMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import FileUpload from "presentation/view/components/FileUpload";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const TariffMappingTitleBar: React.FC = () => {
    const TARIFF_MAPPING_CONSTANT = TariffMappingConstant.Title;
    const tariffMappingVM = useTariffMappingVM();
    const [isLoading, setIsLoading] = useState(false);
    const messageBarVM = useMessageBarVM();
    const [anaInfoState] = useANAInfoTracked();

    const { allowCreate, allowUpdate, operatingUnit } = anaInfoState;
    const handleAdd = useCallback(() => {
        tariffMappingVM.onAddClick(operatingUnit);
    }, [tariffMappingVM, operatingUnit]);

    const handleUpload = useCallback(async (e: any) => {

        const files = e.target?.files;
        const file = files[0];

        if (!file) {
            return;
        }
        if (file.type !== 'text/csv') {
            messageBarVM.showError('Please upload a .csv file');
            return
        }

        setIsLoading(true);
        await tariffMappingVM.onUpload(file).then(async res => {

            // file.current.value = null;
            e.target = null;

            if (res.success) {
                messageBarVM.showSuccess("Success!");
                await tariffMappingVM.searchAllTariffMappingList().then(data => {
                    setIsLoading(false);
                });
            } else {
                setIsLoading(false);
                messageBarVM.showError(res.data);
            }
        });
    }, [messageBarVM, tariffMappingVM]);


    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{TARIFF_MAPPING_CONSTANT.TITLE}</HeaderTitle>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        <StyledAction className="tm-animated-wrapper">
            {(allowCreate) && <><NbisIconButton fileName='Icon-add' disabled={false} size='medium' toolTipText={'Add'} toolTipArrow={false} onClick={handleAdd} />
                <div className="add-seperator" /></>}
            {allowUpdate && <FileUpload handleUpload={handleUpload} label={WorkspaceConstant.Common.BUTTON_UPLOAD} accept=".csv" size={"Small"} theme={"Primary"} disabled={false} />}
        </StyledAction>
    </Sidebarheader>
}

export default memo(TariffMappingTitleBar);